var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('el-date-picker',{attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始时间","end-placeholder":"结束时间","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.value_temp),callback:function ($$v) {_vm.value_temp=$$v},expression:"value_temp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }